/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type MediaAssetFileStatusKind = "AVAILABLE" | "CREATED" | "DELETED" | "ERROR" | "PROCESSING" | "%future added value";
export type MediaAssetStateKind = "AVAILABLE" | "CREATED" | "DELETED" | "PROCESSING" | "%future added value";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type SocialMediaPlatformKind = "ANGEL_LIST" | "FACEBOOK" | "INSTAGRAM" | "LINKED_IN" | "MEDIUM" | "OTHER" | "PINTEREST" | "REDDIT" | "SNAPCHAT" | "TUMBLR" | "TWITTER" | "WEIBO" | "WHATS_APP" | "YOU_TUBE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type userGraphqlQueryVariables = {
    readonly alias: string;
    readonly userIdentityId?: string | null;
    readonly queryParameters?: ReadonlyArray<string> | null;
};
export type userGraphqlQueryResponse = {
    readonly urlRouteByAlias: {
        readonly hasErrors: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly created: unknown | null;
            readonly id: string;
            readonly location: string | null;
            readonly type: string | null;
        } | null> | null;
        readonly node: {
            readonly user: {
                readonly __typename: string;
                readonly id: string;
                readonly fullName: string | null;
                readonly emailAddresses: ReadonlyArray<string> | null;
                readonly accountType: {
                    readonly kind: string;
                    readonly subKind: string | null;
                    readonly description: string | null;
                } | null;
                readonly description: string | null;
                readonly hasPublicPage: boolean | null;
                readonly landingPageUrl: string | null;
                readonly responsibility: string | null;
                readonly isEditable: boolean | null;
                readonly websiteUrl: string | null;
                readonly myList: string | null;
                readonly revision: string | null;
                readonly defaultLocation: {
                    readonly id: string | null;
                    readonly label: string | null;
                } | null;
                readonly locations: ReadonlyArray<{
                    readonly id: string | null;
                    readonly label: string | null;
                }> | null;
                readonly mediaAbout: {
                    readonly edges: ReadonlyArray<{
                        readonly story: ({
                            readonly __typename: string;
                            readonly id?: string;
                            readonly link?: string | null;
                            readonly previews?: {
                                readonly count: number | null;
                                readonly edges: ReadonlyArray<{
                                    readonly cursor: string | null;
                                    readonly preview: {
                                        readonly mediaAsset: {
                                            readonly id: string;
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly heightInPixels: number | null;
                                                readonly widthInPixels: number | null;
                                                readonly path: string | null;
                                                readonly status: {
                                                    readonly kind: MediaAssetFileStatusKind | null;
                                                } | null;
                                            }> | null;
                                            readonly state: {
                                                readonly kind: MediaAssetStateKind | null;
                                            } | null;
                                            readonly topLevelMediaType: {
                                                readonly kind: TopLevelMediaKind | null;
                                            } | null;
                                        } | null;
                                        readonly kind: PreviewKind | null;
                                        readonly link: string | null;
                                    } | null;
                                }> | null;
                            } | null;
                            readonly revision?: string | null;
                            readonly subTitle?: string | null;
                            readonly title?: string | null;
                            readonly description?: string | null;
                            readonly landingPageUrl?: string | null;
                            readonly content?: string | null;
                            readonly publisher?: string | null;
                            readonly publishedDate?: unknown | null;
                        } & ({
                            readonly __typename: "RadivisionPost";
                            readonly id: string;
                            readonly link: string | null;
                            readonly previews: {
                                readonly count: number | null;
                                readonly edges: ReadonlyArray<{
                                    readonly cursor: string | null;
                                    readonly preview: {
                                        readonly mediaAsset: {
                                            readonly id: string;
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly heightInPixels: number | null;
                                                readonly widthInPixels: number | null;
                                                readonly path: string | null;
                                                readonly status: {
                                                    readonly kind: MediaAssetFileStatusKind | null;
                                                } | null;
                                            }> | null;
                                            readonly state: {
                                                readonly kind: MediaAssetStateKind | null;
                                            } | null;
                                            readonly topLevelMediaType: {
                                                readonly kind: TopLevelMediaKind | null;
                                            } | null;
                                        } | null;
                                        readonly kind: PreviewKind | null;
                                        readonly link: string | null;
                                    } | null;
                                }> | null;
                            } | null;
                            readonly revision: string | null;
                            readonly subTitle: string | null;
                            readonly title: string | null;
                            readonly description: string | null;
                            readonly landingPageUrl: string | null;
                            readonly content: string | null;
                        } | {
                            readonly __typename: "ArticleStory";
                            readonly publisher: string | null;
                            readonly publishedDate: unknown | null;
                        } | {
                            /*This will never be '% other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        })) | null;
                    }> | null;
                } | null;
                readonly payments: ReadonlyArray<{
                    readonly created: unknown | null;
                    readonly description: string | null;
                    readonly id: string;
                    readonly cards: ReadonlyArray<{
                        readonly id: string;
                        readonly brand: string | null;
                        readonly funding: string | null;
                        readonly expiryDate: string | null;
                        readonly cardNumber: string | null;
                    } | null> | null;
                    readonly subscriptions: ReadonlyArray<{
                        readonly id: string;
                        readonly status: string | null;
                        readonly startDate: unknown | null;
                        readonly nextBillingDate: unknown | null;
                        readonly method: string | null;
                        readonly metaData: {
                            readonly companyId: string | null;
                            readonly companyName: string | null;
                        } | null;
                        readonly plans: ReadonlyArray<{
                            readonly created: unknown | null;
                            readonly id: string;
                            readonly amount: string | null;
                            readonly recurringInterval: string | null;
                        } | null> | null;
                    } | null> | null;
                }> | null;
                readonly requests: ReadonlyArray<{
                    readonly __typename: "PitchRequest";
                    readonly id?: string;
                    readonly created?: unknown | null;
                    readonly isDeleted?: boolean | null;
                    readonly lastModified?: unknown | null;
                    readonly revision?: string | null;
                    readonly description?: string | null;
                    readonly intentKey?: string | null;
                    readonly item?: ({
                        readonly id?: string;
                        readonly __typename: "Person";
                    } & ({
                        readonly id: string;
                    } | {
                        readonly __typename: "Person";
                    } | {
                        /*This will never be '% other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    })) | null;
                    readonly previews?: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                    readonly status?: string | null;
                    readonly investmentUrl?: string | null;
                    readonly tags?: ReadonlyArray<{
                        readonly id: string;
                        readonly label: string | null;
                    }> | null;
                    readonly peopleEntities?: ReadonlyArray<{
                        readonly person: {
                            readonly id: string;
                            readonly fullName: string | null;
                        } | null;
                        readonly entity: {
                            readonly id: string;
                            readonly name: string | null;
                        } | null;
                    }> | null;
                    readonly expired?: unknown | null;
                    readonly audioMediaAsset?: {
                        readonly id: string;
                        readonly files: ReadonlyArray<{
                            readonly id: string;
                            readonly name: string | null;
                            readonly heightInPixels: number | null;
                            readonly widthInPixels: number | null;
                            readonly path: string | null;
                            readonly status: {
                                readonly kind: MediaAssetFileStatusKind | null;
                            } | null;
                        }> | null;
                        readonly state: {
                            readonly kind: MediaAssetStateKind | null;
                        } | null;
                        readonly topLevelMediaType: {
                            readonly kind: TopLevelMediaKind | null;
                        } | null;
                    } | null;
                    readonly metaData?: {
                        readonly full_name: string | null;
                        readonly title: string | null;
                        readonly company_name: string | null;
                        readonly company_url: string | null;
                        readonly term_agreement: boolean | null;
                    } | null;
                    readonly sample?: {
                        readonly id: string;
                        readonly files: ReadonlyArray<{
                            readonly id: string;
                            readonly name: string | null;
                            readonly heightInPixels: number | null;
                            readonly widthInPixels: number | null;
                            readonly path: string | null;
                            readonly status: {
                                readonly kind: MediaAssetFileStatusKind | null;
                            } | null;
                        }> | null;
                        readonly state: {
                            readonly kind: MediaAssetStateKind | null;
                        } | null;
                        readonly topLevelMediaType: {
                            readonly kind: TopLevelMediaKind | null;
                        } | null;
                    } | null;
                } & ({
                    readonly __typename: "PitchRequest";
                    readonly id: string;
                    readonly created: unknown | null;
                    readonly isDeleted: boolean | null;
                    readonly lastModified: unknown | null;
                    readonly revision: string | null;
                    readonly description: string | null;
                    readonly intentKey: string | null;
                    readonly item: ({
                        readonly id?: string;
                        readonly __typename: "Person";
                    } & ({
                        readonly id: string;
                    } | {
                        readonly __typename: "Person";
                    } | {
                        /*This will never be '% other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    })) | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                    readonly status: string | null;
                    readonly investmentUrl: string | null;
                    readonly tags: ReadonlyArray<{
                        readonly id: string;
                        readonly label: string | null;
                    }> | null;
                    readonly peopleEntities: ReadonlyArray<{
                        readonly person: {
                            readonly id: string;
                            readonly fullName: string | null;
                        } | null;
                        readonly entity: {
                            readonly id: string;
                            readonly name: string | null;
                        } | null;
                    }> | null;
                } | {
                    readonly expired: unknown | null;
                } | {
                    readonly audioMediaAsset: {
                        readonly id: string;
                        readonly files: ReadonlyArray<{
                            readonly id: string;
                            readonly name: string | null;
                            readonly heightInPixels: number | null;
                            readonly widthInPixels: number | null;
                            readonly path: string | null;
                            readonly status: {
                                readonly kind: MediaAssetFileStatusKind | null;
                            } | null;
                        }> | null;
                        readonly state: {
                            readonly kind: MediaAssetStateKind | null;
                        } | null;
                        readonly topLevelMediaType: {
                            readonly kind: TopLevelMediaKind | null;
                        } | null;
                    } | null;
                    readonly metaData: {
                        readonly full_name: string | null;
                        readonly title: string | null;
                        readonly company_name: string | null;
                        readonly company_url: string | null;
                        readonly term_agreement: boolean | null;
                    } | null;
                    readonly sample: {
                        readonly id: string;
                        readonly files: ReadonlyArray<{
                            readonly id: string;
                            readonly name: string | null;
                            readonly heightInPixels: number | null;
                            readonly widthInPixels: number | null;
                            readonly path: string | null;
                            readonly status: {
                                readonly kind: MediaAssetFileStatusKind | null;
                            } | null;
                        }> | null;
                        readonly state: {
                            readonly kind: MediaAssetStateKind | null;
                        } | null;
                        readonly topLevelMediaType: {
                            readonly kind: TopLevelMediaKind | null;
                        } | null;
                    } | null;
                } | {
                    /*This will never be '% other', but we need some
                    value in case none of the concrete values match.*/
                    readonly __typename: "%other";
                })> | null;
                readonly entities: ReadonlyArray<{
                    readonly __typename: string;
                    readonly name: string | null;
                    readonly id: string;
                    readonly revision: string | null;
                    readonly hasPublicPage: boolean | null;
                    readonly landingPageUrl: string | null;
                    readonly description: string | null;
                    readonly tagLine: string | null;
                    readonly websiteUrl: string | null;
                    readonly isEditable: boolean | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                }> | null;
                readonly experience: {
                    readonly edges: ReadonlyArray<{
                        readonly position: {
                            readonly id: string;
                            readonly entity: {
                                readonly __typename: string;
                                readonly name: string | null;
                                readonly description: string | null;
                                readonly websiteUrl: string | null;
                                readonly landingPageUrl: string | null;
                                readonly id: string;
                                readonly hasPublicPage: boolean | null;
                                readonly isEditable: boolean | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            } | null;
                        } | null;
                    }> | null;
                } | null;
                readonly follows: ReadonlyArray<{
                    readonly __typename: "Entity";
                    readonly name?: string | null;
                    readonly id?: string;
                    readonly landingPageUrl?: string | null;
                    readonly previews?: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                    readonly description?: string | null;
                    readonly fullName?: string | null;
                    readonly hasPublicPage?: boolean | null;
                    readonly greeting?: string | null;
                } & ({
                    readonly __typename: "Entity";
                    readonly name: string | null;
                    readonly id: string;
                    readonly landingPageUrl: string | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                } | {
                    readonly description: string | null;
                    readonly fullName: string | null;
                    readonly hasPublicPage: boolean | null;
                    readonly greeting: string | null;
                } | {
                    /*This will never be '% other', but we need some
                    value in case none of the concrete values match.*/
                    readonly __typename: "%other";
                })> | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
                readonly socialMediaProfiles: ReadonlyArray<{
                    readonly id: string;
                    readonly link: string | null;
                    readonly platform: {
                        readonly id: string;
                        readonly kind: SocialMediaPlatformKind | null;
                    } | null;
                }> | null;
                readonly socialMediaCredentials: ReadonlyArray<{
                    readonly credential: string | null;
                    readonly platform: {
                        readonly kind: SocialMediaPlatformKind | null;
                    };
                }> | null;
            } | null;
        } | null;
    } | null;
};
export type userGraphqlQuery = {
    readonly response: userGraphqlQueryResponse;
    readonly variables: userGraphqlQueryVariables;
};



/*
query userGraphqlQuery(
  $alias: String!
  $userIdentityId: ID
  $queryParameters: [String!]
) {
  urlRouteByAlias(alias: $alias, userIdentityId: $userIdentityId, queryParameters: $queryParameters) {
    hasErrors
    errors {
      created
      id
      location
      type
    }
    node {
      user {
        __typename
        id
        fullName
        emailAddresses
        accountType {
          kind
          subKind
          description
        }
        description
        hasPublicPage
        landingPageUrl
        responsibility
        isEditable
        websiteUrl
        myList
        revision
        defaultLocation {
          id
          label
        }
        locations {
          id
          label
        }
        mediaAbout {
          edges {
            story {
              __typename
              ... on RadivisionPost {
                id
                link
                previews(kinds: [SQUARE, CAROUSEL, BACKGROUND]) {
                  count
                  edges {
                    cursor
                    preview {
                      mediaAsset {
                        id
                        files {
                          id
                          name
                          heightInPixels
                          widthInPixels
                          path
                          status {
                            kind
                            id
                          }
                        }
                        state {
                          kind
                          id
                        }
                        topLevelMediaType {
                          kind
                          id
                        }
                      }
                      kind
                      link
                    }
                  }
                }
                revision
                subTitle
                title
                description
                landingPageUrl
                content
              }
              ... on OnlineCourseStory {
                id
                link
                previews(kinds: [SQUARE, CAROUSEL, BACKGROUND]) {
                  count
                  edges {
                    cursor
                    preview {
                      mediaAsset {
                        id
                        files {
                          id
                          name
                          heightInPixels
                          widthInPixels
                          path
                          status {
                            kind
                            id
                          }
                        }
                        state {
                          kind
                          id
                        }
                        topLevelMediaType {
                          kind
                          id
                        }
                      }
                      kind
                      link
                    }
                  }
                }
                revision
                subTitle
                title
              }
              ... on ArticleStory {
                description
                id
                link
                publisher
                publishedDate
                previews(kinds: [SQUARE, CAROUSEL]) {
                  count
                  edges {
                    cursor
                    preview {
                      mediaAsset {
                        id
                        files {
                          id
                          name
                          heightInPixels
                          widthInPixels
                          path
                          status {
                            kind
                            id
                          }
                        }
                        state {
                          kind
                          id
                        }
                        topLevelMediaType {
                          kind
                          id
                        }
                      }
                      kind
                      link
                    }
                  }
                }
                revision
                subTitle
                title
              }
              ... on BookStory {
                id
                link
                publisher
                publishedDate
                previews(kinds: [SQUARE, CAROUSEL]) {
                  count
                  edges {
                    cursor
                    preview {
                      mediaAsset {
                        id
                        files {
                          id
                          name
                          heightInPixels
                          widthInPixels
                          path
                          status {
                            kind
                            id
                          }
                        }
                        state {
                          kind
                          id
                        }
                        topLevelMediaType {
                          kind
                          id
                        }
                      }
                      kind
                      link
                    }
                  }
                }
                revision
                subTitle
                title
              }
              ... on NewsletterStory {
                id
                description
                link
                publisher
                publishedDate
                previews(kinds: [SQUARE, CAROUSEL]) {
                  count
                  edges {
                    cursor
                    preview {
                      mediaAsset {
                        id
                        files {
                          id
                          name
                          heightInPixels
                          widthInPixels
                          path
                          status {
                            kind
                            id
                          }
                        }
                        state {
                          kind
                          id
                        }
                        topLevelMediaType {
                          kind
                          id
                        }
                      }
                      kind
                      link
                    }
                  }
                }
                revision
                subTitle
                title
              }
              ... on PodcastStory {
                id
                link
                publisher
                publishedDate
                previews(kinds: [SQUARE, CAROUSEL]) {
                  count
                  edges {
                    cursor
                    preview {
                      mediaAsset {
                        id
                        files {
                          id
                          name
                          heightInPixels
                          widthInPixels
                          path
                          status {
                            kind
                            id
                          }
                        }
                        state {
                          kind
                          id
                        }
                        topLevelMediaType {
                          kind
                          id
                        }
                      }
                      kind
                      link
                    }
                  }
                }
                revision
                subTitle
                title
              }
              ... on OriginalContentStory {
                id
                previews(kinds: [SQUARE, CAROUSEL]) {
                  count
                  edges {
                    cursor
                    preview {
                      mediaAsset {
                        id
                        files {
                          id
                          name
                          heightInPixels
                          widthInPixels
                          path
                          status {
                            kind
                            id
                          }
                        }
                        state {
                          kind
                          id
                        }
                        topLevelMediaType {
                          kind
                          id
                        }
                      }
                      kind
                      link
                    }
                  }
                }
                revision
                subTitle
                title
              }
              ... on Node {
                id
              }
            }
          }
        }
        payments {
          created
          description
          id
          cards {
            id
            brand
            funding
            expiryDate
            cardNumber
          }
          subscriptions {
            id
            status
            startDate
            nextBillingDate
            method
            metaData {
              companyId
              companyName
            }
            plans {
              created
              id
              amount
              recurringInterval
            }
          }
        }
        requests {
          __typename
          ... on PitchRequest {
            __typename
            id
            created
            isDeleted
            lastModified
            revision
            description
            intentKey
            item {
              __typename
              ... on PitchVideoStory {
                id
              }
              ... on Node {
                id
              }
              ... on SearchHit {
                id
              }
              ... on Tag {
                id
              }
            }
            previews {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
            status
            investmentUrl
            tags {
              id
              label
            }
            peopleEntities {
              person {
                id
                fullName
              }
              entity {
                id
                name
              }
            }
          }
          ... on ClaimRequest {
            __typename
            id
            created
            expired
            description
            item {
              __typename
              ... on Person {
                __typename
                id
              }
              ... on Entity {
                __typename
                id
              }
              ... on Node {
                id
              }
            }
          }
          ... on RSVPRequest {
            __typename
            id
            item {
              __typename
              ... on Event {
                __typename
                id
              }
              ... on Node {
                id
              }
              ... on SearchHit {
                id
              }
              ... on Tag {
                id
              }
            }
          }
          ... on UGCRequest {
            __typename
            id
            created
            revision
            status
            audioMediaAsset {
              id
              files {
                id
                name
                heightInPixels
                widthInPixels
                path
                status {
                  kind
                  id
                }
              }
              state {
                kind
                id
              }
              topLevelMediaType {
                kind
                id
              }
            }
            metaData {
              full_name
              title
              company_name
              company_url
              term_agreement
            }
            previews {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
            sample {
              id
              files {
                id
                name
                heightInPixels
                widthInPixels
                path
                status {
                  kind
                  id
                }
              }
              state {
                kind
                id
              }
              topLevelMediaType {
                kind
                id
              }
            }
          }
          ... on Node {
            id
          }
        }
        entities {
          __typename
          name
          id
          revision
          hasPublicPage
          landingPageUrl
          description
          tagLine
          websiteUrl
          isEditable
          previews(kinds: [SQUARE, LOGO]) {
            count
            edges {
              cursor
              preview {
                mediaAsset {
                  id
                  files {
                    id
                    name
                    heightInPixels
                    widthInPixels
                    path
                    status {
                      kind
                      id
                    }
                  }
                  state {
                    kind
                    id
                  }
                  topLevelMediaType {
                    kind
                    id
                  }
                }
                kind
                link
              }
            }
          }
        }
        experience {
          edges {
            position {
              id
              entity {
                __typename
                name
                description
                websiteUrl
                landingPageUrl
                id
                hasPublicPage
                isEditable
                previews(kinds: [SQUARE, LOGO]) {
                  count
                  edges {
                    cursor
                    preview {
                      mediaAsset {
                        id
                        files {
                          id
                          name
                          heightInPixels
                          widthInPixels
                          path
                          status {
                            kind
                            id
                          }
                        }
                        state {
                          kind
                          id
                        }
                        topLevelMediaType {
                          kind
                          id
                        }
                      }
                      kind
                      link
                    }
                  }
                }
              }
            }
          }
        }
        follows {
          __typename
          ... on Entity {
            __typename
            name
            id
            landingPageUrl
            previews(kinds: [SQUARE, LOGO]) {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
          }
          ... on Person {
            __typename
            description
            fullName
            hasPublicPage
            id
            greeting
            landingPageUrl
            previews(kinds: [SQUARE]) {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
          }
          ... on Node {
            id
          }
        }
        previews {
          count
          edges {
            cursor
            preview {
              mediaAsset {
                id
                files {
                  id
                  name
                  heightInPixels
                  widthInPixels
                  path
                  status {
                    kind
                    id
                  }
                }
                state {
                  kind
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
              kind
              link
            }
          }
        }
        socialMediaProfiles {
          id
          link
          platform {
            id
            kind
          }
        }
        socialMediaCredentials {
          credential
          platform {
            kind
            id
          }
          id
        }
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "alias",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userIdentityId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "queryParameters",
    "type": "[String!]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "alias",
    "variableName": "alias"
  },
  {
    "kind": "Variable",
    "name": "queryParameters",
    "variableName": "queryParameters"
  },
  {
    "kind": "Variable",
    "name": "userIdentityId",
    "variableName": "userIdentityId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "emailAddresses",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "accountType",
  "storageKey": null,
  "args": null,
  "concreteType": "accountType",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "subKind",
      "args": null,
      "storageKey": null
    },
    (v10/*: any*/)
  ]
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasPublicPage",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "responsibility",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isEditable",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "websiteUrl",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "myList",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
},
v19 = [
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  }
],
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "defaultLocation",
  "storageKey": null,
  "args": null,
  "concreteType": "GeographicalLocation",
  "plural": false,
  "selections": (v19/*: any*/)
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "locations",
  "storageKey": null,
  "args": null,
  "concreteType": "GeographicalLocation",
  "plural": true,
  "selections": (v19/*: any*/)
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v23 = [
  {
    "kind": "Literal",
    "name": "kinds",
    "value": [
      "SQUARE",
      "CAROUSEL",
      "BACKGROUND"
    ]
  }
],
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "heightInPixels",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "widthInPixels",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v30 = [
  (v9/*: any*/)
],
v31 = [
  (v4/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "files",
    "storageKey": null,
    "args": null,
    "concreteType": "MediaAssetFile",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "status",
        "storageKey": null,
        "args": null,
        "concreteType": "MediaAssetFileStatus",
        "plural": false,
        "selections": (v30/*: any*/)
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "state",
    "storageKey": null,
    "args": null,
    "concreteType": "MediaAssetState",
    "plural": false,
    "selections": (v30/*: any*/)
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "topLevelMediaType",
    "storageKey": null,
    "args": null,
    "concreteType": "TopLevelMediaType",
    "plural": false,
    "selections": (v30/*: any*/)
  }
],
v32 = [
  (v24/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PreviewEdge",
    "plural": true,
    "selections": [
      (v25/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "preview",
        "storageKey": null,
        "args": null,
        "concreteType": "Preview",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "mediaAsset",
            "storageKey": null,
            "args": null,
            "concreteType": "MediaAsset",
            "plural": false,
            "selections": (v31/*: any*/)
          },
          (v9/*: any*/),
          (v22/*: any*/)
        ]
      }
    ]
  }
],
v33 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": "previews(kinds:[\"SQUARE\",\"CAROUSEL\",\"BACKGROUND\"])",
  "args": (v23/*: any*/),
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": (v32/*: any*/)
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subTitle",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "content",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publisher",
  "args": null,
  "storageKey": null
},
v38 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishedDate",
  "args": null,
  "storageKey": null
},
v39 = [
  {
    "kind": "Literal",
    "name": "kinds",
    "value": [
      "SQUARE",
      "CAROUSEL"
    ]
  }
],
v40 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": "previews(kinds:[\"SQUARE\",\"CAROUSEL\"])",
  "args": (v39/*: any*/),
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": (v32/*: any*/)
},
v41 = [
  (v4/*: any*/),
  (v22/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/),
  (v40/*: any*/),
  (v18/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/)
],
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "payments",
  "storageKey": null,
  "args": null,
  "concreteType": "Payments",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v10/*: any*/),
    (v4/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cards",
      "storageKey": null,
      "args": null,
      "concreteType": "PaymentCard",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "brand",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "funding",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "expiryDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cardNumber",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "subscriptions",
      "storageKey": null,
      "args": null,
      "concreteType": "PaymentSubscription",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v42/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "startDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "nextBillingDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "method",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "metaData",
          "storageKey": null,
          "args": null,
          "concreteType": "SubscriptionMetaData",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "companyId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "companyName",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "plans",
          "storageKey": null,
          "args": null,
          "concreteType": "PaymentPlan",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "amount",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "recurringInterval",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isDeleted",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastModified",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "intentKey",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": (v32/*: any*/)
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "investmentUrl",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "tags",
  "storageKey": null,
  "args": null,
  "concreteType": "Tag",
  "plural": true,
  "selections": (v19/*: any*/)
},
v50 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "peopleEntities",
  "storageKey": null,
  "args": null,
  "concreteType": "EntityPerson",
  "plural": true,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "person",
      "storageKey": null,
      "args": null,
      "concreteType": "Person",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v7/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "entity",
      "storageKey": null,
      "args": null,
      "concreteType": "Entity",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v26/*: any*/)
      ]
    }
  ]
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expired",
  "args": null,
  "storageKey": null
},
v52 = [
  (v6/*: any*/),
  (v4/*: any*/)
],
v53 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "metaData",
  "storageKey": null,
  "args": null,
  "concreteType": "MetaData",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "full_name",
      "args": null,
      "storageKey": null
    },
    (v35/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "company_name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "company_url",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "term_agreement",
      "args": null,
      "storageKey": null
    }
  ]
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tagLine",
  "args": null,
  "storageKey": null
},
v55 = [
  {
    "kind": "Literal",
    "name": "kinds",
    "value": [
      "SQUARE",
      "LOGO"
    ]
  }
],
v56 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": "previews(kinds:[\"SQUARE\",\"LOGO\"])",
  "args": (v55/*: any*/),
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": (v32/*: any*/)
},
v57 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "greeting",
  "args": null,
  "storageKey": null
},
v58 = [
  {
    "kind": "Literal",
    "name": "kinds",
    "value": [
      "SQUARE"
    ]
  }
],
v59 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "socialMediaProfiles",
  "storageKey": null,
  "args": null,
  "concreteType": "SocialMediaProfile",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v22/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "platform",
      "storageKey": null,
      "args": null,
      "concreteType": "SocialMediaPlatform",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v9/*: any*/)
      ]
    }
  ]
},
v60 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "credential",
  "args": null,
  "storageKey": null
},
v61 = [
  (v9/*: any*/),
  (v4/*: any*/)
],
v62 = [
  (v4/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "files",
    "storageKey": null,
    "args": null,
    "concreteType": "MediaAssetFile",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "status",
        "storageKey": null,
        "args": null,
        "concreteType": "MediaAssetFileStatus",
        "plural": false,
        "selections": (v61/*: any*/)
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "state",
    "storageKey": null,
    "args": null,
    "concreteType": "MediaAssetState",
    "plural": false,
    "selections": (v61/*: any*/)
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "topLevelMediaType",
    "storageKey": null,
    "args": null,
    "concreteType": "TopLevelMediaType",
    "plural": false,
    "selections": (v61/*: any*/)
  }
],
v63 = [
  (v24/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PreviewEdge",
    "plural": true,
    "selections": [
      (v25/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "preview",
        "storageKey": null,
        "args": null,
        "concreteType": "Preview",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "mediaAsset",
            "storageKey": null,
            "args": null,
            "concreteType": "MediaAsset",
            "plural": false,
            "selections": (v62/*: any*/)
          },
          (v9/*: any*/),
          (v22/*: any*/)
        ]
      }
    ]
  }
],
v64 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": "previews(kinds:[\"SQUARE\",\"CAROUSEL\",\"BACKGROUND\"])",
  "args": (v23/*: any*/),
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": (v63/*: any*/)
},
v65 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": "previews(kinds:[\"SQUARE\",\"CAROUSEL\"])",
  "args": (v39/*: any*/),
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": (v63/*: any*/)
},
v66 = [
  (v10/*: any*/),
  (v22/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/),
  (v65/*: any*/),
  (v18/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/)
],
v67 = [
  (v22/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/),
  (v65/*: any*/),
  (v18/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/)
],
v68 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": (v63/*: any*/)
},
v69 = [
  (v6/*: any*/)
],
v70 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": "previews(kinds:[\"SQUARE\",\"LOGO\"])",
  "args": (v55/*: any*/),
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": (v63/*: any*/)
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "userGraphqlQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "urlRouteByAlias",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "HtmlDocumentPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "HtmlDocument",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "Person",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v10/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaAbout",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoriesConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StoryEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "story",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "type": "RadivisionPost",
                                "selections": [
                                  (v4/*: any*/),
                                  (v22/*: any*/),
                                  (v33/*: any*/),
                                  (v18/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v10/*: any*/),
                                  (v13/*: any*/),
                                  (v36/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "OnlineCourseStory",
                                "selections": [
                                  (v4/*: any*/),
                                  (v22/*: any*/),
                                  (v33/*: any*/),
                                  (v18/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "ArticleStory",
                                "selections": [
                                  (v10/*: any*/),
                                  (v4/*: any*/),
                                  (v22/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v40/*: any*/),
                                  (v18/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "BookStory",
                                "selections": (v41/*: any*/)
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "NewsletterStory",
                                "selections": [
                                  (v4/*: any*/),
                                  (v10/*: any*/),
                                  (v22/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v40/*: any*/),
                                  (v18/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "PodcastStory",
                                "selections": (v41/*: any*/)
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "OriginalContentStory",
                                "selections": [
                                  (v4/*: any*/),
                                  (v40/*: any*/),
                                  (v18/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v43/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "requests",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "type": "PitchRequest",
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v18/*: any*/),
                          (v10/*: any*/),
                          (v46/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "type": "PitchVideoStory",
                                "selections": [
                                  (v4/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v47/*: any*/),
                          (v42/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ClaimRequest",
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v51/*: any*/),
                          (v10/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "type": "Person",
                                "selections": (v52/*: any*/)
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "Entity",
                                "selections": (v52/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "RSVPRequest",
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "type": "Event",
                                "selections": (v52/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "UGCRequest",
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v18/*: any*/),
                          (v42/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "audioMediaAsset",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaAsset",
                            "plural": false,
                            "selections": (v31/*: any*/)
                          },
                          (v53/*: any*/),
                          (v47/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "sample",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaAsset",
                            "plural": false,
                            "selections": (v31/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "entities",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Entity",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v26/*: any*/),
                      (v4/*: any*/),
                      (v18/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v10/*: any*/),
                      (v54/*: any*/),
                      (v16/*: any*/),
                      (v15/*: any*/),
                      (v56/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "experience",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PositionsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PositionEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "position",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Position",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "entity",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Entity",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v26/*: any*/),
                                  (v10/*: any*/),
                                  (v16/*: any*/),
                                  (v13/*: any*/),
                                  (v4/*: any*/),
                                  (v12/*: any*/),
                                  (v15/*: any*/),
                                  (v56/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "follows",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "type": "Entity",
                        "selections": [
                          (v6/*: any*/),
                          (v26/*: any*/),
                          (v4/*: any*/),
                          (v13/*: any*/),
                          (v56/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "Person",
                        "selections": [
                          (v6/*: any*/),
                          (v10/*: any*/),
                          (v7/*: any*/),
                          (v12/*: any*/),
                          (v4/*: any*/),
                          (v57/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "previews",
                            "storageKey": "previews(kinds:[\"SQUARE\"])",
                            "args": (v58/*: any*/),
                            "concreteType": "PreviewsConnection",
                            "plural": false,
                            "selections": (v32/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  (v47/*: any*/),
                  (v59/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "socialMediaCredentials",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SocialMediaCredential",
                    "plural": true,
                    "selections": [
                      (v60/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "platform",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SocialMediaPlatform",
                        "plural": false,
                        "selections": (v30/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "userGraphqlQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "urlRouteByAlias",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "HtmlDocumentPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "HtmlDocument",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "Person",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v10/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaAbout",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoriesConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StoryEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "story",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "type": "RadivisionPost",
                                "selections": [
                                  (v22/*: any*/),
                                  (v64/*: any*/),
                                  (v18/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v10/*: any*/),
                                  (v13/*: any*/),
                                  (v36/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "OnlineCourseStory",
                                "selections": [
                                  (v22/*: any*/),
                                  (v64/*: any*/),
                                  (v18/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "ArticleStory",
                                "selections": (v66/*: any*/)
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "BookStory",
                                "selections": (v67/*: any*/)
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "NewsletterStory",
                                "selections": (v66/*: any*/)
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "PodcastStory",
                                "selections": (v67/*: any*/)
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "OriginalContentStory",
                                "selections": [
                                  (v65/*: any*/),
                                  (v18/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v43/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "requests",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "PitchRequest",
                        "selections": [
                          (v6/*: any*/),
                          (v3/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v18/*: any*/),
                          (v10/*: any*/),
                          (v46/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": (v52/*: any*/)
                          },
                          (v68/*: any*/),
                          (v42/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ClaimRequest",
                        "selections": [
                          (v6/*: any*/),
                          (v3/*: any*/),
                          (v51/*: any*/),
                          (v10/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "type": "Person",
                                "selections": (v69/*: any*/)
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "Entity",
                                "selections": (v69/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "RSVPRequest",
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "type": "Event",
                                "selections": (v69/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "UGCRequest",
                        "selections": [
                          (v6/*: any*/),
                          (v3/*: any*/),
                          (v18/*: any*/),
                          (v42/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "audioMediaAsset",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaAsset",
                            "plural": false,
                            "selections": (v62/*: any*/)
                          },
                          (v53/*: any*/),
                          (v68/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "sample",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaAsset",
                            "plural": false,
                            "selections": (v62/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "entities",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Entity",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v26/*: any*/),
                      (v4/*: any*/),
                      (v18/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v10/*: any*/),
                      (v54/*: any*/),
                      (v16/*: any*/),
                      (v15/*: any*/),
                      (v70/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "experience",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PositionsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PositionEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "position",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Position",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "entity",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Entity",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v26/*: any*/),
                                  (v10/*: any*/),
                                  (v16/*: any*/),
                                  (v13/*: any*/),
                                  (v4/*: any*/),
                                  (v12/*: any*/),
                                  (v15/*: any*/),
                                  (v70/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "follows",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "Entity",
                        "selections": [
                          (v6/*: any*/),
                          (v26/*: any*/),
                          (v13/*: any*/),
                          (v70/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "Person",
                        "selections": [
                          (v6/*: any*/),
                          (v10/*: any*/),
                          (v7/*: any*/),
                          (v12/*: any*/),
                          (v57/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "previews",
                            "storageKey": "previews(kinds:[\"SQUARE\"])",
                            "args": (v58/*: any*/),
                            "concreteType": "PreviewsConnection",
                            "plural": false,
                            "selections": (v63/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  (v68/*: any*/),
                  (v59/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "socialMediaCredentials",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SocialMediaCredential",
                    "plural": true,
                    "selections": [
                      (v60/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "platform",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SocialMediaPlatform",
                        "plural": false,
                        "selections": (v61/*: any*/)
                      },
                      (v4/*: any*/)
                    ]
                  }
                ]
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "userGraphqlQuery",
    "id": null,
    "text": "query userGraphqlQuery(\n  $alias: String!\n  $userIdentityId: ID\n  $queryParameters: [String!]\n) {\n  urlRouteByAlias(alias: $alias, userIdentityId: $userIdentityId, queryParameters: $queryParameters) {\n    hasErrors\n    errors {\n      created\n      id\n      location\n      type\n    }\n    node {\n      user {\n        __typename\n        id\n        fullName\n        emailAddresses\n        accountType {\n          kind\n          subKind\n          description\n        }\n        description\n        hasPublicPage\n        landingPageUrl\n        responsibility\n        isEditable\n        websiteUrl\n        myList\n        revision\n        defaultLocation {\n          id\n          label\n        }\n        locations {\n          id\n          label\n        }\n        mediaAbout {\n          edges {\n            story {\n              __typename\n              ... on RadivisionPost {\n                id\n                link\n                previews(kinds: [SQUARE, CAROUSEL, BACKGROUND]) {\n                  count\n                  edges {\n                    cursor\n                    preview {\n                      mediaAsset {\n                        id\n                        files {\n                          id\n                          name\n                          heightInPixels\n                          widthInPixels\n                          path\n                          status {\n                            kind\n                            id\n                          }\n                        }\n                        state {\n                          kind\n                          id\n                        }\n                        topLevelMediaType {\n                          kind\n                          id\n                        }\n                      }\n                      kind\n                      link\n                    }\n                  }\n                }\n                revision\n                subTitle\n                title\n                description\n                landingPageUrl\n                content\n              }\n              ... on OnlineCourseStory {\n                id\n                link\n                previews(kinds: [SQUARE, CAROUSEL, BACKGROUND]) {\n                  count\n                  edges {\n                    cursor\n                    preview {\n                      mediaAsset {\n                        id\n                        files {\n                          id\n                          name\n                          heightInPixels\n                          widthInPixels\n                          path\n                          status {\n                            kind\n                            id\n                          }\n                        }\n                        state {\n                          kind\n                          id\n                        }\n                        topLevelMediaType {\n                          kind\n                          id\n                        }\n                      }\n                      kind\n                      link\n                    }\n                  }\n                }\n                revision\n                subTitle\n                title\n              }\n              ... on ArticleStory {\n                description\n                id\n                link\n                publisher\n                publishedDate\n                previews(kinds: [SQUARE, CAROUSEL]) {\n                  count\n                  edges {\n                    cursor\n                    preview {\n                      mediaAsset {\n                        id\n                        files {\n                          id\n                          name\n                          heightInPixels\n                          widthInPixels\n                          path\n                          status {\n                            kind\n                            id\n                          }\n                        }\n                        state {\n                          kind\n                          id\n                        }\n                        topLevelMediaType {\n                          kind\n                          id\n                        }\n                      }\n                      kind\n                      link\n                    }\n                  }\n                }\n                revision\n                subTitle\n                title\n              }\n              ... on BookStory {\n                id\n                link\n                publisher\n                publishedDate\n                previews(kinds: [SQUARE, CAROUSEL]) {\n                  count\n                  edges {\n                    cursor\n                    preview {\n                      mediaAsset {\n                        id\n                        files {\n                          id\n                          name\n                          heightInPixels\n                          widthInPixels\n                          path\n                          status {\n                            kind\n                            id\n                          }\n                        }\n                        state {\n                          kind\n                          id\n                        }\n                        topLevelMediaType {\n                          kind\n                          id\n                        }\n                      }\n                      kind\n                      link\n                    }\n                  }\n                }\n                revision\n                subTitle\n                title\n              }\n              ... on NewsletterStory {\n                id\n                description\n                link\n                publisher\n                publishedDate\n                previews(kinds: [SQUARE, CAROUSEL]) {\n                  count\n                  edges {\n                    cursor\n                    preview {\n                      mediaAsset {\n                        id\n                        files {\n                          id\n                          name\n                          heightInPixels\n                          widthInPixels\n                          path\n                          status {\n                            kind\n                            id\n                          }\n                        }\n                        state {\n                          kind\n                          id\n                        }\n                        topLevelMediaType {\n                          kind\n                          id\n                        }\n                      }\n                      kind\n                      link\n                    }\n                  }\n                }\n                revision\n                subTitle\n                title\n              }\n              ... on PodcastStory {\n                id\n                link\n                publisher\n                publishedDate\n                previews(kinds: [SQUARE, CAROUSEL]) {\n                  count\n                  edges {\n                    cursor\n                    preview {\n                      mediaAsset {\n                        id\n                        files {\n                          id\n                          name\n                          heightInPixels\n                          widthInPixels\n                          path\n                          status {\n                            kind\n                            id\n                          }\n                        }\n                        state {\n                          kind\n                          id\n                        }\n                        topLevelMediaType {\n                          kind\n                          id\n                        }\n                      }\n                      kind\n                      link\n                    }\n                  }\n                }\n                revision\n                subTitle\n                title\n              }\n              ... on OriginalContentStory {\n                id\n                previews(kinds: [SQUARE, CAROUSEL]) {\n                  count\n                  edges {\n                    cursor\n                    preview {\n                      mediaAsset {\n                        id\n                        files {\n                          id\n                          name\n                          heightInPixels\n                          widthInPixels\n                          path\n                          status {\n                            kind\n                            id\n                          }\n                        }\n                        state {\n                          kind\n                          id\n                        }\n                        topLevelMediaType {\n                          kind\n                          id\n                        }\n                      }\n                      kind\n                      link\n                    }\n                  }\n                }\n                revision\n                subTitle\n                title\n              }\n              ... on Node {\n                id\n              }\n            }\n          }\n        }\n        payments {\n          created\n          description\n          id\n          cards {\n            id\n            brand\n            funding\n            expiryDate\n            cardNumber\n          }\n          subscriptions {\n            id\n            status\n            startDate\n            nextBillingDate\n            method\n            metaData {\n              companyId\n              companyName\n            }\n            plans {\n              created\n              id\n              amount\n              recurringInterval\n            }\n          }\n        }\n        requests {\n          __typename\n          ... on PitchRequest {\n            __typename\n            id\n            created\n            isDeleted\n            lastModified\n            revision\n            description\n            intentKey\n            item {\n              __typename\n              ... on PitchVideoStory {\n                id\n              }\n              ... on Node {\n                id\n              }\n              ... on SearchHit {\n                id\n              }\n              ... on Tag {\n                id\n              }\n            }\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n            status\n            investmentUrl\n            tags {\n              id\n              label\n            }\n            peopleEntities {\n              person {\n                id\n                fullName\n              }\n              entity {\n                id\n                name\n              }\n            }\n          }\n          ... on ClaimRequest {\n            __typename\n            id\n            created\n            expired\n            description\n            item {\n              __typename\n              ... on Person {\n                __typename\n                id\n              }\n              ... on Entity {\n                __typename\n                id\n              }\n              ... on Node {\n                id\n              }\n            }\n          }\n          ... on RSVPRequest {\n            __typename\n            id\n            item {\n              __typename\n              ... on Event {\n                __typename\n                id\n              }\n              ... on Node {\n                id\n              }\n              ... on SearchHit {\n                id\n              }\n              ... on Tag {\n                id\n              }\n            }\n          }\n          ... on UGCRequest {\n            __typename\n            id\n            created\n            revision\n            status\n            audioMediaAsset {\n              id\n              files {\n                id\n                name\n                heightInPixels\n                widthInPixels\n                path\n                status {\n                  kind\n                  id\n                }\n              }\n              state {\n                kind\n                id\n              }\n              topLevelMediaType {\n                kind\n                id\n              }\n            }\n            metaData {\n              full_name\n              title\n              company_name\n              company_url\n              term_agreement\n            }\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n            sample {\n              id\n              files {\n                id\n                name\n                heightInPixels\n                widthInPixels\n                path\n                status {\n                  kind\n                  id\n                }\n              }\n              state {\n                kind\n                id\n              }\n              topLevelMediaType {\n                kind\n                id\n              }\n            }\n          }\n          ... on Node {\n            id\n          }\n        }\n        entities {\n          __typename\n          name\n          id\n          revision\n          hasPublicPage\n          landingPageUrl\n          description\n          tagLine\n          websiteUrl\n          isEditable\n          previews(kinds: [SQUARE, LOGO]) {\n            count\n            edges {\n              cursor\n              preview {\n                mediaAsset {\n                  id\n                  files {\n                    id\n                    name\n                    heightInPixels\n                    widthInPixels\n                    path\n                    status {\n                      kind\n                      id\n                    }\n                  }\n                  state {\n                    kind\n                    id\n                  }\n                  topLevelMediaType {\n                    kind\n                    id\n                  }\n                }\n                kind\n                link\n              }\n            }\n          }\n        }\n        experience {\n          edges {\n            position {\n              id\n              entity {\n                __typename\n                name\n                description\n                websiteUrl\n                landingPageUrl\n                id\n                hasPublicPage\n                isEditable\n                previews(kinds: [SQUARE, LOGO]) {\n                  count\n                  edges {\n                    cursor\n                    preview {\n                      mediaAsset {\n                        id\n                        files {\n                          id\n                          name\n                          heightInPixels\n                          widthInPixels\n                          path\n                          status {\n                            kind\n                            id\n                          }\n                        }\n                        state {\n                          kind\n                          id\n                        }\n                        topLevelMediaType {\n                          kind\n                          id\n                        }\n                      }\n                      kind\n                      link\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        follows {\n          __typename\n          ... on Entity {\n            __typename\n            name\n            id\n            landingPageUrl\n            previews(kinds: [SQUARE, LOGO]) {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n          }\n          ... on Person {\n            __typename\n            description\n            fullName\n            hasPublicPage\n            id\n            greeting\n            landingPageUrl\n            previews(kinds: [SQUARE]) {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n          }\n          ... on Node {\n            id\n          }\n        }\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              mediaAsset {\n                id\n                files {\n                  id\n                  name\n                  heightInPixels\n                  widthInPixels\n                  path\n                  status {\n                    kind\n                    id\n                  }\n                }\n                state {\n                  kind\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n              kind\n              link\n            }\n          }\n        }\n        socialMediaProfiles {\n          id\n          link\n          platform {\n            id\n            kind\n          }\n        }\n        socialMediaCredentials {\n          credential\n          platform {\n            kind\n            id\n          }\n          id\n        }\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '518a8ce7d36f7d903b56923fc1455e4e';
export default node;
